var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.is_registered)?_c('div',[_c('EventManagementRegisterForm',{on:{"registration-success":_vm.onRegistrationSuccess}})],1):_c('div',[_c('RegisteredForm',{attrs:{"ticket-data":_vm.ticketData,"response-message":_vm.responseMessage}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }